// MF-568 — Card 'pat-response-guttman': "Response chart". Students (highest score on top) × items (easiest on the
// left); C / X / - always printed, colour is secondary. A step line per student marks the boundary between items
// at/below the student's score and items above it (a model reference, not a mastery boundary).
import { useMemo } from 'react'
import { Box, Typography } from '@mui/material'
import { SUMMARY_PALETTE } from '../boardTheme'
import PatSkillsGrid, { Legend, Note } from './patSkillsGrid'
import { RESPONSE_STYLE, adaptiveNote, buildMatrix } from './patSkillsShared'

const cellStyle = (_s, _it, response) => ({
  bg: RESPONSE_STYLE[response].bg,
  fg: RESPONSE_STYLE[response].fg,
  title: RESPONSE_STYLE[response].label
})

const PatResponseGuttmanCard = ({ data }) => {
  const matrix = useMemo(() => buildMatrix(data?.rows || []), [data?.rows])
  return (
    <Box sx={{ height: '100%', minWidth: 0, display: 'flex', flexDirection: 'column', overflow: 'auto' }}>
      <Typography sx={{ fontSize: 14, fontWeight: 600, color: SUMMARY_PALETTE.ink, mb: 0.5 }}>
        Response chart
      </Typography>
      <Legend
        entries={[
          { symbol: 'C', ...RESPONSE_STYLE.C, label: 'Correct' },
          { symbol: 'X', ...RESPONSE_STYLE.X, label: 'Incorrect' },
          { symbol: '-', ...RESPONSE_STYLE['-'], label: 'Not administered' }
        ]}
      />
      {adaptiveNote(matrix) ? <Note>{adaptiveNote(matrix)}</Note> : null}
      <PatSkillsGrid matrix={matrix} cellStyle={cellStyle} stepLine />
      <Note>
        Step line: the boundary between items at/below each student score and items above it. It is a model
        reference, not a mastery boundary. Correct responses beyond it and errors before it are worth
        investigating.
      </Note>
    </Box>
  )
}

export default PatResponseGuttmanCard
